import { makeStyles } from '@material-ui/core';

export default makeStyles(
  () => ({
    card: {
      padding: '40px 60px',
      maxWidth: '440px',
    },
  }),
  { name: 'someName' },
);
